export default __webpack_public_path__ + "static/media/shopping_cart_icon.eaa47fea.svg";